import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { userInfo } from 'os';
import React, { useEffect, useRef, useState } from 'react';
import { Button, ListGroup, Toast } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import SyncLoader from 'react-spinners/SyncLoader';
import { useDebouncedCallback } from 'use-debounce';
import { SET_TIP, useLeadContext } from '../../context/Lead';
import { setTip } from '../../features/user/userSlice';
import { pink500 } from '../../ui/colors';
import ToastWrapper from '../ToastWrapper';
interface TipSelectionProps {
  setTipHandler?: any;
  source?: string;
  totalPriceFromThankYou?: any;
  customer?: any;
  id?: any;
  setTipFromThankYou?: any;
  autoLeadTipHandler?: any;
  leadPackage?: any;
  checkBoxHandler?: any;
}
const TipSelection: React.FC<TipSelectionProps> = ({
  setTipHandler,
  source,
  totalPriceFromThankYou,
  customer,
  id,
  setTipFromThankYou,
  autoLeadTipHandler,
  leadPackage,
  checkBoxHandler,
}: TipSelectionProps) => {
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [customValue, setCustomValue] = useState<any>('');
  const [scale, setScale] = useState<string>('');
  const [tipValue, setTipValue] = useState<any>(0);
  const [tipSubmitted, setTipSubmitted] = useState<boolean>(false);
  const [tipDisabled, setTipDisabled] = useState<boolean>(true);
  const [autoTipApply, setAutoTipApply] = useState<boolean>(true);
  const [futureTips, setFutureTips] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [serviceFee, setServiceFee] = useState<number>(0);
  const [leadId, setLeadId] = useState<number>(0);
  const dispatch = useDispatch();
  const customInputRef = useRef(null);

  const recurringPackages = [6, 8, 10, 5, 7, 2, 4];

  const lead = useLeadContext();
  if (source === 'confirm') {
    var { dispatchLead } = useLeadContext();
  }
  useEffect(() => {
    if (lead !== null) {
      let leadRecurringId = 0;
      let recurringServiceFee = 0;

      if (leadId === 0) {
        if (lead.lead.id > 0) {
          leadRecurringId = lead.lead.id;
          recurringServiceFee = lead.lead.serviceFee;
          // setLeadId(lead.lead.id);
          // setServiceFee(lead.lead.serviceFee);
        }
      }
      if (lead?.lead.addressLineOne?.length > 0 && tipDisabled) {
        setTipDisabled(false);
        if (source === 'confirm') {

          const leadTotalPrice =
            Number(lead?.lead.price) +
            Number(lead?.lead.tax) +
            Number(lead?.lead.serviceFee);

          const tenPercent = (leadTotalPrice * 0.1).toFixed(2);
          const fifteenPercent = (leadTotalPrice * 0.15).toFixed(2);
          const twentyPercent = (leadTotalPrice * 0.2).toFixed(2);
          const leadTip = Number(lead?.lead.tip)
          
          if (leadTip <= 0) {
            setTipHandler(fifteenPercent);
            triggerScale('fifteen');
          } else if (Number(lead.lead.tip) === Number(tenPercent)) {
            setTipHandler(tenPercent);
            triggerScale('ten');
            if (leadRecurringId > 0) {
              submitRecurringPartial(
                leadRecurringId,
                tenPercent,
                recurringServiceFee
              );
            } else {
              submitPartial(tenPercent);
            }
            autoLeadTipHandler(false);
          } else if (Number(lead.lead.tip) === Number(fifteenPercent)) {
            setTipHandler(fifteenPercent);
            triggerScale('fifteen');
          } else if (Number(lead.lead.tip) === Number(twentyPercent)) {
            setTipHandler(twentyPercent);
            triggerScale('twenty');
            if (leadRecurringId > 0) {
              submitRecurringPartial(
                leadRecurringId,
                twentyPercent,
                recurringServiceFee
              );
            } else {
              submitPartial(twentyPercent);
            }
            autoLeadTipHandler(false);
          } else {
            setTipHandler(lead.lead.tip);
            setCustomValue(lead.lead.tip);
            if (leadRecurringId > 0) {
              submitRecurringPartial(
                leadRecurringId,
                lead.lead.tip,
                recurringServiceFee
              );
            } else {
              submitPartial(lead.lead.tip);
            }
            autoLeadTipHandler(false);
          }
        }
      }
    }
  }, [lead]);

  const submitRecurringPartial = (
    recurringId,
    recurringTip,
    recurringServiceFee
  ) => {
    axios
      .post('/api/set-lead-tip/', {
        tip: recurringTip,
        service_fee: recurringServiceFee,
        id: recurringId,
      })
      .then((res) => {
        if (source === 'confirm') {
          dispatchLead({
            type: SET_TIP,
            payload: {
              tip: recurringTip,
              totalPrice: res.data.total_price,
            },
          });
        }
      })
      .catch((err) => console.log(err));
    submitCustomerTipCookie(recurringTip);
  };

  useEffect(() => {
    axios
      .get('/api/lead-session/')
      .then((res) => {
        const price = Number(res.data?.data?.lead?.price);
        const leadServiceFee = Number(res.data?.data?.lead?.serviceFee);
        const leadTax = Number(res.data?.data?.lead?.tax);

        const leadTotalPrice = price + leadServiceFee + leadTax;
        setTotalPrice(leadTotalPrice);
      })
      .catch((err) => {
        console.log(err);
        if (source === 'thank-you') {
          setTotalPrice(totalPriceFromThankYou);
        }
      });
  }, []);
  const parseStringToAbsolute = (input: string) => Math.abs(parseInt(input));

  const triggerScale = (value) => {
    setScale(value);
  };

  useEffect(() => {
    if (isNaN(totalPrice)) setTotalPrice(totalPriceFromThankYou);
  }, [totalPrice]);

  const submitCustomerTipCookie = async (value) => {
    try {
      const response = await axios.post('/api/tips-session/', {
        tipsData: {
          tips: value,
          id: id,
          customer: customer,
        },
      });
    } catch (e) {
      console.log(e);
    }
  };
  const handleTipFromThankYou = (value) => {
    setLoading(true);
    axios
      .post('/api/set-appointment-tip/', {
        tip: Number(value),
        id: id,
        customer: customer,
      })
      .then((res) => {
        setTipSubmitted(true);
        setLoading(false);
        // setCustomValue()
      })
      .catch((err) => console.log(err));
  };

  const handleTipFromThankYouCustomField = useDebouncedCallback(
    (value) => {
      if (source === 'thank-you') {
        handleTipFromThankYou(value);
      } else {
        submitPartial(value);
        // if (value !== user.selectedPackage.value) {
        // }
      }
    },
    1000,
    { trailing: true }
  );

  useEffect(() => {
    let lead;
    axios
      .get('/api/lead-session/')
      .then((res) => {
        lead = res.data.data.lead;
        setServiceFee(lead.serviceFee);
        setLeadId(lead.id);
      })
      .catch((err) => console.log(err));
  }, []);

  const submitPartial = (value) => {
    axios
      .post('/api/set-lead-tip/', {
        tip: Number(value),
        service_fee: serviceFee,
        id: leadId,
      })
      .then((res) => {
        setLoading(false);
        // setCustomValue()
        if (source === 'confirm') {
          dispatchLead({
            type: SET_TIP,
            payload: {
              tip: value,
              totalPrice: res.data.total_price,
            },
          });
        }
      })
      .catch((err) => console.log(err));
    submitCustomerTipCookie(value);
  };

  const toggleChecked = (event) => {
    checkBoxHandler(event.target.checked);
    if (event.target.checked === true) {
      setFutureTips(true);
      return;
    } else {
      setFutureTips(false);
    }
  };

  const handleTipSelection = (value, percent) => {
    if (source === 'confirm') {
      autoLeadTipHandler(false);
    }
    if (source === 'confirm' && scale !== percent) {
      setTipHandler(value);
      submitPartial(value);
      submitCustomerTipCookie(value);
      dispatch(setTip(value));
    } else if (source === 'thank-you' && scale !== percent) {
      setTipValue(value);
      handleTipFromThankYou(value);
      setTipFromThankYou(value);
    } else if (source === 'customer-thank-you' && scale !== percent) {
      submitPartial(value);
      setTipFromThankYou(value);
      setTipValue(value);
    }
    // else if (source === 'thank-you' && scale === percent) {
    //   autoLeadTipHandler(false);
    // }

    setCustomValue(0);
    if (scale === percent) {
      triggerScale('');
      if (source === 'confirm') {
        submitPartial(0);
        setTipHandler(0);
        submitCustomerTipCookie(0);
        dispatch(setTip(0));
      } else if (source === 'customer-thank-you') {
        submitPartial(0);
        setTipFromThankYou(0);
      } else {
        handleTipFromThankYou(0);
        setTipFromThankYou(0);
      }
      return;
    }
    triggerScale(percent);
  };

  const handleCustomTip = (num) => {
    setTipValue(num);
    setCustomValue(num);
  };

  return (
    <div className='tip-main-container mb-3'>
      {source === 'thank-you' && (
        <div
          className='tip-loader'
          style={{ position: 'absolute', right: '0' }}
        >
          <SyncLoader color={pink500} size={5} loading={loading} />
        </div>
      )}

      <hr className='mt-4' />

      <div
        className={`mb-4 tip-heading font-weight-bold mt-4 mb-2 text-left form-section-header ${
          source === 'confirm' && tipDisabled ? 'tip-disable' : ''
        }`}
      >
        Professional House Cleaners Tip
        <div className='tooltip-tip-selection'>
          {' '}
        </div>
      </div>

      <div
        className={`tip-container ${
          source === 'confirm' && tipDisabled ? 'tip-disable' : ''
        }`}
      >
        <div
          className={`tip-box stable ${scale === 'ten' ? 'active' : ''} ${
            source === 'thank-you' ? ' tip-box-thank-you' : ''
          }`}
          tabIndex={0}
          role='button'
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              let price = '';
              price = (totalPrice * 0.1).toFixed(2);
              handleTipSelection(price, 'ten');
            }
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            let price = '';
            price = (totalPrice * 0.1).toFixed(2);
            handleTipSelection(price, 'ten');
          }}
        >
          <h5>10%</h5>
          <p>${(totalPrice * 0.1).toFixed(2)}</p>
        </div>
        <div
          className={`tip-box stable ${scale === 'fifteen' ? 'active' : ''}${
            source === 'thank-you' ? ' tip-box-thank-you' : ''
          }`}
          tabIndex={0}
          role='button'
          onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                let price = '';
                price = (totalPrice * 0.15).toFixed(2);
                handleTipSelection(price, 'fifteen');
              }
            }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            let price = '';
            price = (totalPrice * 0.15).toFixed(2);
            handleTipSelection(price, 'fifteen');
          }}
        >
          <h5>15%</h5>
          
          <p>${(totalPrice * 0.15).toFixed(2)}</p>
          
        </div>
        <div
          className={`tip-box stable ${scale === 'twenty' ? 'active' : ''}${
            source === 'thank-you' ? ' tip-box-thank-you' : ''
          }`}
          tabIndex={0}
          role='button'
          onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                let price = '';
                price = (totalPrice * 0.2).toFixed(2);
                handleTipSelection(price, 'twenty');
              }
            }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            let price = '';
            price = (totalPrice * 0.2).toFixed(2); 
            handleTipSelection(price, 'twenty');
          }}
        >
          <h5>20%</h5>
          <p>${(totalPrice * 0.2).toFixed(2)}</p>
        </div>
        <div
          className={`tip-box stable ${
            scale === 'custom' || customValue > 0 ? 'active' : ''
          }${source === 'thank-you' ? ' tip-box-thank-you' : ''}`}
          onClick={() => {
            customInputRef.current.focus();
            setTipHandler(0);
          }}
        >
          <h5>Custom</h5>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginLeft: '5px',
            }}
          >
            {/* <span>$</span> */}
            <input
              ref={customInputRef}
              pattern='[-+]?(\d*[.])?\d+'
              value={isNaN(customValue) ? '' : customValue}
              placeholder={'0'}
              onChange={(e) => {
                let num = parseStringToAbsolute(e.target.value);
                // Bring Back
                // if (num > totalPrice) {
                // if (source === 'confirm') {
                //   setTipHandler(totalPrice);
                // }
                // setTipValue(totalPrice);
                // setCustomValue(totalPrice);
                
                if (source === 'confirm') {
                  if (num > totalPrice) {
                    num = totalPrice;
                  }
                  setTipHandler(num);
                  handleTipFromThankYouCustomField.callback(
                    isNaN(num) ? 0 : num
                  );
                  autoLeadTipHandler(false);
                }
                handleCustomTip(num);
                if (source === 'thank-you') {
                  setTipFromThankYou(isNaN(num) ? 0 : num);
                  handleTipFromThankYouCustomField.callback(
                    isNaN(num) ? 0 : num
                  );
                }
                if (source === 'customer-thank-you') {
                  setTipFromThankYou(isNaN(num) ? 0 : num);
                  handleTipFromThankYouCustomField.callback(
                    isNaN(num) ? 0 : num
                  );
                }
                if (num < 0 || isNaN(num)) {
                  if (source === 'confirm') {
                    setTipHandler(0);
                  }
                }
              }}
              onFocus={(e) => {
                let num = e.target.value;

                handleCustomTip(parseStringToAbsolute(num));
                handleTipFromThankYouCustomField.callback(num);
                if (scale === 'custom') {
                  if (source === 'confirm') {
                    setTipHandler(0);
                  }
                  return;
                }
                triggerScale('custom');
              }}
            />
          </div>
        </div>
        <div
          className={`tip-box stable ${scale === 'no' ? 'active' : ''}${
            source === 'thank-you' ? ' tip-box-thank-you' : ''
          }`}
          tabIndex={0}
          role='button'
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                let price = '0';
                handleTipSelection(price, 'no');
              }}
          }
          
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            let price = '0'; 
            handleTipSelection(price, 'no');
          }}
        >
        <h5>Maybe Later</h5>
        <p>(Skip)</p>
        </div>
      </div>
      <ToastWrapper>
        <Toast
          show={tipSubmitted}
          onClose={() => setTipSubmitted(false)}
          autohide
          delay={8000}
        >
          <Toast.Body>
            <ListGroup>
              <ListGroup.Item variant='success'>
                Tip Submitted Successfully
              </ListGroup.Item>
            </ListGroup>
          </Toast.Body>
        </Toast>
      </ToastWrapper>
      <p className='tip-bottom-text'>
        100% of the tip goes to your Professional House Cleaners.
      </p>

      {recurringPackages.includes(
        source === 'thank-you' || source === 'customer-thank-you'
          ? Number(leadPackage)
          : Number(lead?.lead?.package)
      ) &&
        source === 'confirm' && (
          <div className='d-flex justify-content-start mt-1'>
            <Form.Check
              aria-label='agree to the terms and conditions'
              disabled={tipDisabled}
              onClick={toggleChecked}
              className='pr-3 confirm-checkbox'
              checked={futureTips}
            />
            <p
              style={{
                color: '#d3367f',
                fontSize: '16px',
                fontWeight: 'bold',
                marginBottom: '0px',
                fontFamily: 'Gotham Bold'
              }}
            >
              Add tip to future cleans?
            </p>
          </div>
        )}

      <hr className='mt-4' />
    </div>
  );
};

export default TipSelection;
